import { useFormContext, useWatch } from 'react-hook-form';
import { DashboardPageFormBody } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../../lib/messages';
import type { CreativeFormValue } from '../../creativeFormSchema';
import { CreativeVariantsList } from '../CreativeVariantsList';

export function CreativeVariantsFields() {
  const form = useFormContext<CreativeFormValue>();
  const variants = useWatch({ control: form.control, name: 'variants' });
  return (
    <DashboardPageFormBody width="lg" title={dashboardT('creatives.variants')}>
      <CreativeVariantsList
        variants={variants}
        onToggle={(index, active) => {
          form.setValue(
            'variants',
            variants.map((item, itemIndex) => (itemIndex === index ? { ...item, active } : item)),
            { shouldDirty: true },
          );
        }}
      />
    </DashboardPageFormBody>
  );
}
